import { g as getOriginalSource, a as getOriginalLandingPage } from "../../../analytics-plugin-original-source.browser.es-e6f690eb.js";
import { EVENT_ORIGIN } from "../../constants/analytics.es.js";
import { getUtmParams } from "./getUtmParams.es.js";
import { m as mapKeys } from "../../../mapKeys-251205e5.js";
import { p as pickFields } from "../../../pickFields-27454ddf.js";
const extractCommonPayload = (payload, application) => {
  var _a, _b, _c, _d, _e;
  const originalSources = mapKeys(
    (key) => "original_utm_" + key,
    getOriginalSource()
  );
  const whitelistedProperties = pickFields(
    [
      "campaign",
      "cerebro_id",
      "cta_text",
      "cta_value",
      "click_url",
      "event_id",
      "event_type",
      "page_name"
    ],
    payload.properties
  );
  return {
    ...whitelistedProperties,
    application,
    browser_height: payload.properties.height,
    browser_width: payload.properties.width,
    event_datetime: payload.meta.ts,
    event_origin: payload.properties.event_origin || EVENT_ORIGIN.CLIENT,
    event_type: payload.type,
    meta_title: (_a = payload == null ? void 0 : payload.properties) == null ? void 0 : _a.title,
    original_landing_page: getOriginalLandingPage(),
    url: payload.properties.url,
    url_hash: (_b = payload.properties) == null ? void 0 : _b.hash,
    url_path: (_c = payload.properties) == null ? void 0 : _c.path,
    url_search: (_d = payload.properties) == null ? void 0 : _d.search,
    user_agent: navigator.userAgent,
    ...getUtmParams((_e = payload.properties) == null ? void 0 : _e.search),
    ...originalSources
  };
};
const stringifyAdditionalInfo = (experiment) => {
  if (experiment.additional_info) {
    return {
      ...experiment,
      additional_info: typeof experiment.additional_info !== "string" ? JSON.stringify(experiment.additional_info) : experiment.additional_info
    };
  }
  return experiment;
};
const extractExperiments = (payload) => {
  const experiments = payload.properties.experiments;
  if (!experiments || !Array.isArray(experiments)) {
    return experiments;
  }
  return experiments.map((experiment) => stringifyAdditionalInfo(experiment));
};
export {
  extractCommonPayload,
  extractExperiments,
  stringifyAdditionalInfo
};
